import css from '../../../utils/css';

export default css`
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
    src: url(https://betfanatics.com/_next/static/media/e4af272ccee01ff0-s.p.woff2)
      format('woff2');
  }

  :host {
    --widget-font-family: 'Inter', sans-serif;

    --fanatics-background: #121317;
    --fanatics-black: #000;
    --fanatics-grey: #474747;
    --fanatics-red: #e53c2e;
    --fanatics-white: #fff;

    --oc-bg-grey-light: var(--fanatics-grey);
    --ogm-grid-odds-tooltip-bg-color: var(--fanatics-grey);
    --widget-odds-drifting: #ffafba66;
    --widget-odds-drifting-bg: #ffafba;
    --widget-odds-shortening: #8cccf266;
    --widget-odds-shortening-bg: #8cccf2;

    --widget-grid-best-odds-border-color: var(--fanatics-red);

    --widget-grid-best-odds-mobile-bg-color: var(--fanatics-grey);
    --widget-grid-odds-mobile-bg-color: var(--fanatics-grey);

    --widget-background-color: var(--fanatics-background);
    --widget-show-more-background-color: var(--fanatics-grey);

    --widget-text-color: var(--fanatics-white);
    --widget-border-color: var(--fanatics-black);
    --widget-divider-color: var(--fanatics-white);
    --widget-not-supported-bet-name-text-color: var(--fanatics-white);

    --widget-header-bg-color: var(--fanatics-grey);
    --widget-header-text-color: var(--fanatics-white);
    --widget-header-odds-shadow: #ccc;

    --widget-grid-compare-active-bg-color: var(--fanatics-red);
    --widget-grid-compare-color: var(--fanatics-black);

    --widget-mobile-seeall-color: var(--fanatics-black);

    --widget-grid-best-odds-bg-color: var(--fanatics-red);
    --widget-grid-best-odds-border-color: var(--fanatics-red);
    --widget-grid-best-odds-text-color: var(--fanatics-white);

    [class*='bestOddsStyles'] svg path:first-child {
      fill: currentColor;
    }

    [class*='bestOddsStyles'] svg path:nth-child(2),
    [class*='bestOddsStyles'] svg path:nth-child(3) {
      stroke: var(--fanatics-white);
    }

    button[class*='GridToggler'] {
      color: var(--fanatics-white);
      background: var(--fanatics-red);
      font-family: var(--widget-font-family);
    }

    [class*='oddDrifting'],
    [class*='oddShortening'],
    button[class*='drifter'],
    button[class*='steamer'] {
      color: var(--fanatics-black);
    }

    [class*='SeeAllOdds'] {
      color: var(--fanatics-red);
    }
  }
`;
